import { Component, EventEmitter, Input, Output } from '@angular/core';

import { TableConfig } from 'app/shared/util/table-config.utils';

import { Equipment } from '@models/equipment.model';
import { Log } from "ng2-logger";

@Component({
    selector: 'app-equipment-table',
    templateUrl: './equipment-table.component.html',
    styleUrls: ['./equipment-table.component.scss']
})
export class EquipmentTableComponent {
    _logger = Log.create(EquipmentTableComponent.name);
    @Input() equipment: Equipment[] = [];
    @Input() tableConfig: TableConfig;
    @Input() isLoading = false;
    @Input() headerBackgroundColor: string;
    @Input() hasTitle = true;

    @Output() pageChange = new EventEmitter<any>();
    @Output() filterChange = new EventEmitter<any>();
    @Output() sortChange = new EventEmitter<any>();
    @Output() rowClick = new EventEmitter<any>();
    @Output() duplicate = new EventEmitter<any>();

    onPageChange(tableConfig: TableConfig) {
        this._logger.info("onPageChange::", tableConfig);
        this.pageChange.emit(tableConfig);
    }

    onSortChange(tableConfig: TableConfig) {
        this._logger.info("onSortChange::", tableConfig);
        this.sortChange.emit(tableConfig);
    }

    onFilterChange(tableConfig: TableConfig) {
        this._logger.info("onFilterChange::", tableConfig);
        this.filterChange.emit(tableConfig);
    }

    onRowClick(clickedItem) {
        this._logger.info("onRowClick::", clickedItem);
        this.rowClick.emit(clickedItem);
    }

    onDuplicate(duplicate) {
        this._logger.info("onDuplicate::", duplicate);
        this.duplicate.emit(duplicate);
    }

}
